export default function (item) {
  return item.contentId;
}
